module.exports = __webpack_public_path__ + "img/hr-level2addon_mining_tool_shadow-2.19f6fbbe.png";